module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/NetworkTable-332ca66b0942a11c234fca2cc7b8b1ee.png";